import { BULK_ACTIONS_RESOURCES, PAGE_NAMES } from 'constant';

export const makeActionHandler = (action: any, params: any) => {
	const { history } = params;

	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `/${PAGE_NAMES.bulkActions}/${BULK_ACTIONS_RESOURCES.bulkReply}/create`
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
